import { render } from "./MyChallenge.vue?vue&type=template&id=47eb69d4"
import script from "./MyChallenge.vue?vue&type=script&lang=ts"
export * from "./MyChallenge.vue?vue&type=script&lang=ts"
script.render = render

export default script